(function () {
  function applyBisButtonStyling(scope) {
    var root = scope || document;
    var containers = root.querySelectorAll('#klaviyo-bis-button-container');

    containers.forEach(function (container) {
      var bisButton = container.querySelector('button');
      if (!bisButton) return;

      var form = container.closest('form');
      if (!form) return;

      var referenceButton = form.querySelector('.klaviyo-bis-reference');
      if (!referenceButton) return;

      var ref = window.getComputedStyle(referenceButton);

      bisButton.classList.add('button', 'w-full', 'custom-bis-button');

      container.style.width = '100%';
      container.style.marginBottom = '0';
      container.style.flex = 'unset';

      var inner = container.firstElementChild;
      if (inner) {
        inner.style.width = '100%';
        inner.style.margin = '0';
      }

      bisButton.style.width = '100%';
      bisButton.style.paddingTop = ref.paddingTop;
      bisButton.style.paddingRight = ref.paddingRight;
      bisButton.style.paddingBottom = ref.paddingBottom;
      bisButton.style.paddingLeft = ref.paddingLeft;

      bisButton.style.fontFamily = ref.fontFamily;
      bisButton.style.fontSize = ref.fontSize;
      bisButton.style.fontWeight = ref.fontWeight;
      bisButton.style.lineHeight = ref.lineHeight;
      bisButton.style.letterSpacing = ref.letterSpacing;
      bisButton.style.textTransform = ref.textTransform;
      bisButton.style.whiteSpace = ref.whiteSpace;
      bisButton.style.minHeight = ref.minHeight;
      bisButton.style.boxSizing = 'border-box';
    });
  }

  function runBisFix() {
    applyBisButtonStyling(document);
  }

  function initBisFix() {
    runBisFix();

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;

          if (
            node.id === 'klaviyo-bis-button-container' ||
            node.querySelector('#klaviyo-bis-button-container')
          ) {
            applyBisButtonStyling(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener('change', function () {
      setTimeout(runBisFix, 150);
    });

    document.addEventListener('click', function () {
      setTimeout(runBisFix, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBisFix);
  } else {
    initBisFix();
  }
})();